import { CategoryQuestions } from '../types';

export const zenAfQuestions: CategoryQuestions = {
  title: 'Get Your Personalized Zen AF Session',
  questions: {
    preferredStyle: {
      label: 'How zen do you want this session to be?',
      type: 'radio',
      options: ['Real talk - straight up', 'Balanced zen with edge', 'Maximum chill vibes', 'Deep wisdom mode']
    },
    primaryGoal: {
      label: 'What do you need most right now?',
      type: 'radio',
      options: ['Let go of this bullshit', 'Find some actual peace', 'Get real perspective', 'Process these feelings', 'Stop overthinking everything', 'Just breathe and chill']
    },
    specificFocus: {
      label: "What's bothering you today?",
      type: 'textarea',
      placeholder: 'Tell me what\'s really getting to you right now...',
      maxLength: 2000
    },
    deeperReason: {
      label: 'Why?',
      type: 'textarea',
      placeholder: 'What\'s the deeper reason this is affecting you?',
      maxLength: 2000
    },
    explicitLanguageLevel: {
      label: 'Explicit Language Level (1-10)',
      type: 'slider',
      min: 1,
      max: 10,
      defaultValue: 8
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for you?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  },
  groupTitle: 'Get Your Group Zen AF Session - Real Talk for Real Issues',
  groupQuestions: {
    preferredStyle: {
      label: 'How zen does your group want this session?',
      type: 'radio',
      options: ['Real talk - straight up', 'Balanced zen with edge', 'Maximum chill vibes', 'Deep wisdom mode']
    },
    primaryGoal: {
      label: 'What does your group need most right now?',
      type: 'radio',
      options: ['Let go of this bullshit together', 'Find some actual peace as a group', 'Get real perspective', 'Process these feelings collectively', 'Stop overthinking everything', 'Just breathe and chill together']
    },
    groupFrustration: {
      label: "What's pissing off your group right now?",
      type: 'textarea',
      placeholder: 'Tell me what\'s really getting to everyone - be brutally honest...',
      maxLength: 2000
    },
    deeperReason: {
      label: 'Why is this affecting your group so deeply?',
      type: 'textarea',
      placeholder: 'What\'s the deeper reason this is hitting everyone so hard?',
      maxLength: 2000
    },
    explicitLanguageLevel: {
      label: 'Explicit Language Level (1-10)',
      type: 'slider',
      min: 1,
      max: 10,
      defaultValue: 8
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your group?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  },
  practitionerTitle: 'Get Your Client\'s Personalized Zen AF Session',
  practitionerQuestions: {
    preferredStyle: {
      label: 'How zen should this session be for your client?',
      type: 'radio',
      options: ['Real talk - straight up', 'Balanced zen with edge', 'Maximum chill vibes', 'Deep wisdom mode']
    },
    primaryGoal: {
      label: 'What does your client need most right now?',
      type: 'radio',
      options: ['Let go of this bullshit', 'Find some actual peace', 'Get real perspective', 'Process these feelings', 'Stop overthinking everything', 'Just breathe and chill']
    },
    specificFocus: {
      label: "What's bothering your client today?",
      type: 'textarea',
      placeholder: 'Tell me what\'s really getting to your client right now...',
      maxLength: 2000
    },
    deeperReason: {
      label: 'Why?',
      type: 'textarea',
      placeholder: 'What\'s the deeper reason this is affecting your client?',
      maxLength: 2000
    },
    explicitLanguageLevel: {
      label: 'Explicit Language Level (1-10)',
      type: 'slider',
      min: 1,
      max: 10,
      defaultValue: 8
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your client?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  practitionerGroupTitle: 'Get Your Clients\' Zen AF Group Session - Real Talk for Real Issues',
  practitionerGroupQuestions: {
    preferredStyle: {
      label: 'How zen should this session be for your clients?',
      type: 'radio',
      options: ['Real talk - straight up', 'Balanced zen with edge', 'Maximum chill vibes', 'Deep wisdom mode']
    },
    primaryGoal: {
      label: 'What do your clients need most right now?',
      type: 'radio',
      options: ['Let go of this bullshit together', 'Find some actual peace as a group', 'Get real perspective', 'Process these feelings collectively', 'Stop overthinking everything', 'Just breathe and chill together']
    },
    groupFrustration: {
      label: "What's bothering your clients today?",
      type: 'textarea',
      placeholder: 'Tell me what\'s really getting to your clients right now - be brutally honest...',
      maxLength: 2000
    },
    deeperReason: {
      label: 'Why is this affecting your clients so deeply?',
      type: 'textarea',
      placeholder: 'What\'s the deeper reason this is hitting them so hard?',
      maxLength: 2000
    },
    explicitLanguageLevel: {
      label: 'Explicit Language Level (1-10)',
      type: 'slider',
      min: 1,
      max: 10,
      defaultValue: 8
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your clients?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  },
  giftTitle: 'Get Your Loved One\'s Personalized Zen AF Session',
  giftQuestions: {
    primaryGoal: {
      label: 'What does your loved one need most right now?',
      type: 'radio',
      options: ['Let go of this bullshit', 'Find some actual peace', 'Get real perspective', 'Process these feelings', 'Stop overthinking everything', 'Just breathe and chill']
    },
    specificFocus: {
      label: "What's pissing off your loved one right now?",
      type: 'textarea',
      placeholder: 'Tell me what\'s really getting to them - be brutally honest...',
      maxLength: 2000
    },
    deeperReason: {
      label: 'Why is this affecting them so deeply?',
      type: 'textarea',
      placeholder: 'What\'s the deeper reason this is hitting them so hard?',
      maxLength: 2000
    },
    explicitLanguageLevel: {
      label: 'Explicit Language Level (1-10)',
      type: 'slider',
      min: 1,
      max: 10,
      defaultValue: 8
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for them?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  }
};